import { supabase } from './supabase';
import {
  buildEspelhoEmailHTML, buildEspelhoEmailSubject,
  buildNFEmitidaEmailHTML, buildNFEmitidaEmailSubject,
} from './email-template';

async function sendViaServer({ to, subject, html, replyTo, solicitacao_id, fromName, replicaSlug }) {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) throw new Error('Sessão expirada — faça login novamente.');

  // confirmHost passa o origin atual pro server saber pra onde os links
  // de confirmacao apontam (cobre custom domain + preview deploys).
  const confirmHost = typeof window !== 'undefined' ? window.location.origin : undefined;

  const r = await fetch('/api/send-email', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session.access_token}`,
    },
    // fromName: server troca so o display name do remetente.
    // replica: server le RESEND_FROM_<SLUG> e usa esse endereco como base
    //          (se a env existir). Caso contrario fallback no RESEND_FROM.
    body: JSON.stringify({ to, subject, html, replyTo, solicitacao_id, confirmHost, fromName, replica: replicaSlug }),
  });

  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data?.error || `Falha no envio (HTTP ${r.status}).`);
  return data;
}

/**
 * Envia o espelho da NF por email (pre-emissao).
 *
 * Passa solicitacao.id pro server gerar os tokens dos botoes 'Aprovar /
 * Recusar' (placeholders {{APPROVE_URL}} / {{REJECT_URL}} no HTML).
 */
export async function sendEspelhoEmail({
  solicitacao, empresa, tomador, servico, to, replyTo,
  // Overrides opcionais por replica:
  fromName,                     // ex: 'FATURAMENTO BHAZ' (so display name)
  subjectPrefix,                // ex: 'Nota fácil BHAZ' (prefixo do subject)
  showAvisoFormaPagamento,      // mostra caixa amarela no HTML do espelho
  replicaSlug,                  // ex: 'bhaz' (server le RESEND_FROM_BHAZ)
  usePIInSubject,               // BHAZ: usa PI da solicitacao em vez do OS-XXX
}) {
  const html = buildEspelhoEmailHTML({
    solicitacao, empresa, tomador, servico,
    showAvisoFormaPagamento,
  });
  const subject = buildEspelhoEmailSubject({ solicitacao, empresa, tomador, subjectPrefix, usePIInSubject });
  return sendViaServer({
    to, subject, html, replyTo,
    solicitacao_id: solicitacao?.id,
    fromName,
    replicaSlug,
  });
}

/**
 * Envia o email de NF EMITIDA (pos-emissao, com link pro arquivo).
 *
 * Passa solicitacao.id pro server gerar o token do botao 'Confirmo o
 * recebimento da NF' (placeholder {{RECEIPT_URL}} no HTML).
 */
export async function sendNFEmitidaEmail({
  solicitacao, empresa, tomador, servico, to, replyTo,
  fromName,
  replicaSlug,
  usePIInSubject,               // BHAZ: append '· PI <numero>' ao subject
  showReceiptCTAOnTop,          // BHAZ: sobe o botao 'Confirmar recebimento'
                                //       pra logo abaixo do 'Abrir arquivo'
                                //       e some com o card duplicado do rodape.
}) {
  const html = buildNFEmitidaEmailHTML({ solicitacao, empresa, tomador, servico, showReceiptCTAOnTop });
  const subject = buildNFEmitidaEmailSubject({ solicitacao, empresa, tomador, usePIInSubject });
  return sendViaServer({
    to, subject, html, replyTo,
    solicitacao_id: solicitacao?.id,
    fromName,
    replicaSlug,
  });
}
